import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';

export const Field = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 40px;
`;

export const SplitField = styled.div<{ disableMargin?: boolean }>`
  @media ${from(Device.Tablet)} {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }

  ${({ disableMargin }) =>
    disableMargin &&
    css`
      ${() => Field} {
        margin-bottom: 0 !important;
      }
    `}
`;

export const baseControl = css<{ error?: boolean }>`
  display: block;
  height: 45px;
  width: 100%;
  padding: 0 12px;
  border: none;
  appearance: none;
  border-radius: 4px;
  font-size: 12px;
  color: ${brand.black};
  background-color: ${brand.white};
  ${fonts.helvetica['63-medium-extended']};
  transition: background-color 300ms ease;

  &::placeholder {
    color: ${brand.grey[65]};
  }

  &:focus {
    &::placeholder {
      color: ${brand.grey[55]};
    }
  }

  &[disabled] {
    opacity: 0.5;
  }
`;

export const baseControlUnderline = css`
  display: block;
  height: 45px;
  width: 100%;
  padding: 10px 20px 9px;
  background-color: transparent;
  // adding all borders to stop text from shifting when border is added on focus
  border: 2px solid transparent;
  border-bottom-color: ${brand.white};
  appearance: none;
  border-radius: 0;
  font-size: 16px;
  color: ${brand.white};
  ${fonts.helvetica['53-extended']};
  transition: opacity 0.3s ease;
  position: relative;
  z-index: 2;

  &::placeholder {
    color: ${brand.white};
  }
`;

export const Label = styled.label`
  display: block;
  color: ${brand.white};
  ${fonts.helvetica['63-medium-extended']};
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 10px;

  a {
    color: ${brand.white};
    text-decoration: underline;
  }
`;

export const ErrorLabel = styled.span`
  display: block;
`;

export type ErrorTextTheme = 'white' | 'black' | 'red';

export const ErrorText = styled.span<{
  theme?: ErrorTextTheme;
  italicText?: boolean;
  withIcon?: boolean;
}>`
  ${fonts.helvetica['55-roman']};
  font-size: 16px;
  line-height: 32px;

  ${({ theme }) => {
    switch (theme) {
      case 'black':
        return css`
          color: ${brand.black};
        `;

      case 'red':
        return css`
          color: ${brand.red.base};
        `;

      case 'white':
      default:
        return css`
          color: ${brand.white};
        `;
    }
  }}

  ${({ italicText }) =>
    italicText &&
    css`
      font-size: 12px;
      line-height: 16px;
      font-style: italic !important;
    `}

  ${({ withIcon }) =>
    withIcon &&
    css`
      display: flex;
      align-items: center;
      margin-top: 8px;
    `}


  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-right: 8px;
  }
`;

export const DescriptionText = styled.span<{ blackText?: boolean; italicText?: boolean; withIcon?: boolean }>`
  ${fonts.helvetica['55-roman']};
  font-size: 13px;
  color: ${({ blackText }) => (blackText === undefined ? `${brand.white}` : `${brand.black}`)};
  line-height: 30px;

  ${({ italicText }) =>
    italicText &&
    css`
      font-size: 12px;
      line-height: 16px;
      font-style: italic !important;
    `}

  ${({ withIcon }) =>
    withIcon &&
    css`
      display: flex;
      align-items: center;
      margin-top: 8px;
    `}

  a {
    color: ${({ blackText }) => (blackText === undefined ? `${brand.white}` : `${brand.black}`)};
    text-decoration: underline;
  }

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-right: 8px;
  }
`;
